import React from 'react';
import { LayoutPanelLeft, CheckCircle2, ArrowRight } from 'lucide-react';
export function InteriorGlass() {
  const bullets = ['Office glass walls and dividers', 'Conference room glass and full-height partitions', 'Half walls and interior partitions', 'Countertop sliding systems', 'Pass-through windows for privacy and security', 'Commercial mirror systems and specialty interior glass'];
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-151">
          <div data-id="element-152">
            <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-sm bg-slate-50 aspect-[4/3]" data-id="element-153">
              {/* Office glass wall illustration */}
              <svg viewBox="0 0 400 300" className="w-full h-full" role="img" aria-label="Office glass wall installation in a Michigan commercial building" data-id="element-154">
                <rect width="400" height="300" fill="#f1f5f9" data-id="element-155" />
                {/* Floor */}
                <rect x="0" y="240" width="400" height="60" fill="#94a3b8" opacity="0.3" data-id="element-156" />
                {/* Back wall */}
                <rect x="0" y="0" width="400" height="240" fill="#f8fafc" data-id="element-157" />
                {/* Glass wall frame */}
                <rect x="30" y="50" width="340" height="190" fill="none" stroke="#1e293b" strokeWidth="3" data-id="element-158" />
                {/* Vertical mullions */}
                <line x1="115" y1="50" x2="115" y2="240" stroke="#1e293b" strokeWidth="2" data-id="element-159" />
                <line x1="200" y1="50" x2="200" y2="240" stroke="#1e293b" strokeWidth="2" data-id="element-160" />
                <line x1="285" y1="50" x2="285" y2="240" stroke="#1e293b" strokeWidth="2" data-id="element-161" />
                {/* Door panel */}
                <rect x="200" y="50" width="85" height="190" fill="#dbeafe" opacity="0.5" data-id="element-162" />
                <circle cx="275" cy="145" r="3" fill="#f59e0b" data-id="element-163" />
                {/* Glass tint on other panels */}
                <rect x="33" y="53" width="79" height="184" fill="#dbeafe" opacity="0.35" data-id="element-164" />
                <rect x="118" y="53" width="79" height="184" fill="#dbeafe" opacity="0.4" data-id="element-165" />
                <rect x="288" y="53" width="79" height="184" fill="#dbeafe" opacity="0.35" data-id="element-166" />
                {/* Reflection lines */}
                <line x1="50" y1="70" x2="80" y2="130" stroke="#ffffff" strokeWidth="2" opacity="0.7" data-id="element-167" />
                <line x1="135" y1="70" x2="165" y2="130" stroke="#ffffff" strokeWidth="2" opacity="0.7" data-id="element-168" />
                <line x1="305" y1="70" x2="335" y2="130" stroke="#ffffff" strokeWidth="2" opacity="0.7" data-id="element-169" />
                {/* Ceiling track */}
                <rect x="30" y="46" width="340" height="6" fill="#1e293b" data-id="element-170" />
              </svg>
            </div>
          </div>

          <div data-id="element-171">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4" data-id="element-172">
              Interior Commercial Glass
            </div>
            <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-173">
              Office Glass Walls, Dividers & Interior Glass
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-174">
              Open up your floor plan and bring more daylight into your
              workspace with office glass wall installation, conference rooms,
              partitions, pass-through windows and specialty interior glazing
              for offices, retail, healthcare and professional buildings.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-175">
              {bullets.map((b, i) => <li key={i} className="flex items-start gap-3" data-id="element-176">
                  <CheckCircle2 className="w-5 h-5 text-primary-600 shrink-0 mt-0.5" data-id="element-177" />
                  <span className="text-slate-700 font-medium" data-id="element-178">{b}</span>
                </li>)}
            </ul>
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="inline-flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-semibold py-3 px-6 rounded-lg transition-colors group" data-id="element-179">
              Plan an Office Glass Wall Project
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-180" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}